<template>
    <!--普通表格-->
    <div class="container" :style='{width:(this.$store.state.windowwidth-this.$store.state.leftBlockWidth-this.$store.state.ResetrouterNavWidth-topWidth-this.$store.state.indexPadding*2 - topWidth)+"px", height:(this.$store.state.windowHeight-topHegiht)+"px",padding:tablePadding}'>
        <!--插槽-->
        <slot></slot>
        <ShowBtns v-if="showBtn"/>
        <div class="warp-table">
            <el-table :ref="ref" :data="tableData" empty-text="." :size="this.$store.state.tableSize" style="width:100%;"  row-key="id"  :height="this.$store.state.windowHeight-navHeight" lazy   @selection-change="checkBtn">
                <template v-for="(item,index) in columns" >
                    <!--通过render函数返回的自定义-->
                    <template v-if="!!item.render">
                      <el-table-column    
                            :prop="item.prop"        
                            :label="item.label" 
                            :width="item.width"
                            :header-align="item.headerAlign"
                            :align="item.align"
                            :fixed="item.fixed"
                        >
                            <template slot-scope="scope" >
                                <Custom :render="item.render" :row="scope.row" :index="scope.$index"/>
                            </template>
                        </el-table-column>
                    </template>
                    <!--纯文本-->
                    <template v-else>
                        <el-table-column 
                           :key = "index" 
                           :prop="item.prop"  
                           :label="item.label" 
                           :width="item.width" 
                           :header-align="item.headerAlign"
                           :align="item.align"
                           :type = 'item.type'
                           :show-overflow-tooltip="item.tooltip"
                           />
                    </template>
                </template>
            </el-table>
            <div class="empty" v-if="tableData.length==0">
               <el-empty description="数据空空" :image-size="100"></el-empty>
            </div>
            <template v-if="ispage">
              <BlockPage @getPage="getPage" :total="total" :pageNo="current" :size="size"/>
            </template>
        </div>
    </div>
  </template>
  <script>
  import store from '@/utils/store';
  import {scroll } from '@/components/component-mixin/block-scroll'
  import Custom from './custom.vue'
  import {postFun} from '@/utils/httpFun'
  import {setRouterNav} from '@/utils/util'
  import BlockPage from '../module-page/index.vue'
  export default {
    name: 'commonTable',
    // mixins: [scroll],
    components:{
      Custom,
      BlockPage
    },
    props:{
        tablePadding:{
          type:String,
          default:()=>'15px'
        },
        columns: {
          type: Array,
          default: () => []
		    },
        navHeight:{
          type: Number,
          default: () => 0
        },
        topWidth:{
          type:Number,
          default: () => 0
        },
        topHegiht:{
          type:Number,
          default: () => 130
        },
        topWidth:{
          type:Number,
          default: () => 0
        },
        //接口域名
        action:{
          type: String,
          default: () => ''
        },

        //参数
        param:{
          type: Object,
			    default: () => ({})
        },

        //是否显示伸缩按钮
        showBtn:{
          type: Boolean,
			    default: () => false
        },
        
        //页面加载的时候进行请求
        autRequest:{
          type: Boolean,
			    default: () => true
        },
        //是否分页
        ispage:{
          type: Boolean,
			    default: () => true
        },
    },
    data:()=>({ 
      ref:'giftTable', 
      tableData: [],
      current:1,
      size:0,
      total:0,   
    }),
    created(){
       this.size = this.$store.state.pageSize
    },
    mounted(){
      if(this.autRequest){
          this.getDatas()
      }
      if(this.showBtn){
        setRouterNav()
      }else{
        store.commit({
            type: "setResetrouterNavWidth",
            ResetrouterNavWidth:0,
         })
      }
    },
    methods:{
      // 获取tableData
      getTableData(){
        return this.tableData;
      },
      //获取所有的数据
      async getDatas(){
          //有分页 
          let parms = {
              param:this.param,
              current:this.current,
              size:this.size
          }
          
          //如果没有接口地址就停止请求
          if(!this.action){
             return
          }
          let parmswu = this.param
          await postFun(this.action, this.ispage ? parms:parmswu,res=>{  
              //有分页
              if(this.ispage){
                this.tableData = !res.data ? [] : res.data.records

                // for(let i =0;i<30;i++){
                //   this.tableData.push({...res.data.records[0]})
                // }

                // this.total = 30 || 0
                // this.current = 1|| 0
                this.total = res.data.total || 0
                this.current = res.data.current || 0
                this.$nextTick(res=>{
                  localStorage.setItem("sortNumber",this.total+1)
                })
              }else{
                this.tableData = !res.data ? [] : res.data
                this.$nextTick(res=>{
                    localStorage.setItem("sortNumber",this.tableData.length+1)
                })
              }
          })
      },
       //外置分页查询
       async getPageDatas(page){
          //有分页 
          let parms = {
              param:this.param,
              current:page.pageNo,
              size:page.pageSize
          }
          await postFun(this.action, parms,res=>{
                this.tableData = !res.data ? [] : res.data.records

                if(this.tableData.length == 0){
                  if(page.pageNo == 1){
                    page.isNext = true;
                    page.isPre = true;
                  }else if(page.pageNo == 0){
                    page.isPre = true
                  }
                  else{
                    page.isNext = true;
                  }
                }else{
                  if(page.pageNo == 1){
                    page.isNext = false;
                    page.isPre = false;
                  }
                }
          })
      },
      //复选框
      checkBtn(ev){
          this.$emit("checkVal",ev)
      },
      
      //重置到第一页
      resetHttp(){
          this.current = 1
          this.$nextTick(res=>{
               this.getDatas()
          }) 
      },

      //分页
      getPage(ev){
          this.size = ev.pageSize
          this.current = ev.pageNo 
          this.getDatas()
      }
    }
  }
  </script>
  <style lang="scss" scoped>
      .container{
          // padding:15px;
          position: relative;
          border: 1px solid rgba(240,240,240,0.2);
          box-shadow: -3px 3px 9px 0px rgba(205,216,233,0.2);
          box-sizing: border-box;
      }
      .warp-table{
          margin-top:15px;
          width:100%;
          position: relative;
          .empty{
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            z-index:10;
            display: flex;
            justify-content: space-around;
            align-items: center;
          }
      }
      ::v-deep .el-button--mini{
        padding: 5px 8px;
      }
      ::v-deep .el-table th.el-table__cell{
        background-color: #F5F6F7 !important;
        color: #6C7174;
      }
  </style>
  